import { createFileRoute, notFound } from '@tanstack/react-router';
import { ExternalDisplayGeometryHarness } from 'containers/ExternalDisplay/ExternalDisplayFeature';

export const Route = createFileRoute('/__e2e/external-display')({
  beforeLoad: () => {
    if (process.env.NODE_ENV === 'production') throw notFound();
  },
  component: ExternalDisplayGeometryHarness,
});
